import { IFilter } from 'core-components/types'
import { IDataProviderFilter } from 'core-components/types'
import { getTokens } from 'core/classes/helpers/StorageHelper'
import { proxy } from 'core/classes/helpers/UrlHelper'
import { HttpHeaders, Rest } from 'core/classes/http'

export const fetchPartnersByPartnerIds = async (filter: IDataProviderFilter) => {
  const url = proxy(`/webservice/197/sp/v3/spJBPPartnerInfoByCustomFilter/call`)
  const filters = filter.filters as IFilter[]
  const partnerIdsFilter = filters.find((f) => f.field === 'Ids')

  if (partnerIdsFilter) {
    const payload = {
      'p.Filter': JSON.stringify(partnerIdsFilter.value),
    }
    const [accessToken] = getTokens()
    const headers = new HttpHeaders()
    if (accessToken) {
      headers.add('Authorization', `Bearer ${accessToken}`)
    }

    const response = await Rest.post({ url, payload, headers })
    const rows = (response && response['Rows']) || []

    return { Data: rows }
  }

  return { Data: [] }
}
